import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SkipButtonGroup } from '../skip-button-group/component';
import { useSkipWithAnalytics } from '../../../hooks/skin/use-skip';

import { useAutoSkipWithAnalytics } from './hooks/use-auto-skip';
import { useIsAutoSkipEnabled } from './hooks/use-is-auto-skip-enabled';

interface Props {
    contentId: string;
    className?: string;
    currentFragment: SkippableFragment;
}

export const IntroSkipButtonGroup: FC<Props> = ({ currentFragment, className, contentId }) => {
    const { isSkipEnabled, skip, cancel, onSkipButtonShow } = useSkipWithAnalytics(currentFragment);

    const { isAutoSkipEnabled, enableAutoSkip, disableAutoSkip } = useIsAutoSkipEnabled({
        contentId,
    });

    const autoSkipTime = useAutoSkipWithAnalytics({
        isAutoSkipEnabled,
        currentFragment,
    });

    const intl = useIntl();

    if (!isSkipEnabled) {
        return null;
    }

    return (
        <SkipButtonGroup
            cancelButtonText={intl.formatMessage({
                id: 'features.player.3c030a04cd8f2130b3d3f45d878f2f07',
                defaultMessage: 'View intro',
                description: 'Текст кнопки оставить заставку в секции кнопок в скине плеера',
            })}
            onSkipClick={() => {
                skip();
                enableAutoSkip();
            }}
            onCancelClick={() => {
                cancel();
                disableAutoSkip();
            }}
            className={className}
            autoSkipTime={autoSkipTime}
            onSkipButtonShow={onSkipButtonShow}
        />
    );
};

IntroSkipButtonGroup.displayName = 'IntroSkipButtonGroupContainer';
